import { format } from 'date-fns';
import { TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import './index.scss';

export const SensorChartTooltip: React.FC<TooltipProps<ValueType, NameType>> = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const {
      name,
      value,
      payload: { unit },
    } = payload[0];
    const timestamp = label
      ? format(new Date(label as number), 'dd.MM, HH:mm')
      : format(new Date(value as number), 'dd.MM, HH:mm');

    return (
      <div className="sensor-chart-tooltip">
        <p className="label">{timestamp}</p>
        {label && <p className="value">{`${name}: ${value} ${unit || ''}`}</p>}
      </div>
    );
  }

  return null;
};
